import { render } from "./DSSCriterion.vue?vue&type=template&id=44aec910"
import script from "./DSSCriterion.vue?vue&type=script&lang=js"
export * from "./DSSCriterion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__